import * as React from 'react';

import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

import type {Comparator} from 'nutshell-graphql-types';

const COMPARATOR_OPTIONS = [
    {value: 'GREATER', label: '>'},
    {value: 'LESS', label: '<'},
    {value: 'EQUAL', label: '='},
];

type Props = {
    onChange: (option: {value: Comparator}) => void;
    comparitorValue: Comparator;
};

export const ComparitorSelector = ({onChange, comparitorValue}: Props) => (
    <SelectPickerGeneric
        value={COMPARATOR_OPTIONS.filter(({value}) => value === comparitorValue)}
        options={COMPARATOR_OPTIONS}
        isClearable={false}
        isSearchable={false}
        styles={{
            // @ts-expect-error
            container: (base) => ({
                ...base,
                flexBasis: 72,
                marginRight: 10,
            }),
            // @ts-expect-error
            control: (base) => ({
                ...base,
                top: 0,
            }),
        }}
        onChange={onChange}
    />
);
